import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["logo", "menuItems", "menu", "mobileBtn", "closeBtn", "dropdownToggle", "dropdownTrigger", "dropdownContent", "dropdownIcon", "scrollToTop", "stickyFooter", "button"];

    connect() {
        this.element.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', this.smoothScroll.bind(this));
        });
        
        if (this.hasScrollToTopTarget) {
            this.scrollToTopTarget.classList.add('hidden');
            window.addEventListener('scroll', this.handleScroll.bind(this));
        }

        document.addEventListener('click', this.handleClickOutside.bind(this));

        if (this.hasButtonTarget) {
            this.buttonTarget.classList.remove("pointer-events-none");
        }
    }

    disconnect() {
        this.element.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.removeEventListener('click', this.smoothScroll.bind(this));
        });
        
        if (this.hasScrollToTopTarget) {
            window.removeEventListener('scroll', this.handleScroll.bind(this));
        }

        document.removeEventListener('click', this.handleClickOutside.bind(this));
    }

    handleClickOutside(event) {
        if (!event.target.closest('[data-navigation-target="dropdownWrapper"]') && 
            !event.target.closest('[data-modal-target="wrapper"]')) {
            this.closeAllDropdowns();
        }
    }

    handleScroll() {
        if (this.hasScrollToTopTarget) {
            if (window.scrollY > 200) {
                this.scrollToTopTarget.classList.remove('hidden');
            } else {
                this.scrollToTopTarget.classList.add('hidden');
            }
        }
    }

    smoothScroll(event) {
        event.preventDefault();
        const anchor = event.currentTarget;
        const targetId = anchor.getAttribute('href');
        
        if (!targetId || targetId === '#') return;
        
        const targetElement = document.querySelector(targetId);
        if (!targetElement) return;

        this.dropdownContentTargets.forEach(content => {
            content.classList.add('hidden');
        });
        this.dropdownIconTargets.forEach(icon => {
            icon.classList.remove('rotate-180');
        });

        if (this.hasMenuTarget && !this.menuTarget.classList.contains('hidden')) {
            this.toggleMenu();
        }

        const headerOffset = 80;
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.history.pushState(null, '', targetId);

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    toggleMenu() {
        this.menuTarget.classList.toggle('hidden');
        const isHidden = this.menuTarget.classList.contains('hidden');
        document.body.style.overflow = isHidden ? 'auto' : 'hidden';

        if (isHidden) {
            this.menuTarget.setAttribute('inert', '');
            this.menuTarget.setAttribute('aria-hidden', 'true');
        } else {
            this.menuTarget.removeAttribute('inert');
            this.menuTarget.setAttribute('aria-hidden', 'false');
        }
        
        const stickyFooter = document.querySelector('.sticky.bottom-0');
        if (stickyFooter) {
            if (isHidden) {
                stickyFooter.classList.remove('hidden');
            } else {
                stickyFooter.classList.add('hidden');
            }
        }
    }

    closeAllDropdowns() {
        this.dropdownTriggerTargets.forEach(trigger => {
            const wrapper = trigger.closest('[data-navigation-target="dropdownWrapper"]');
            const content = wrapper.querySelector('[data-navigation-target="dropdownContent"]');
            const icon = wrapper.querySelector('[data-navigation-target="dropdownIcon"]');
            
            content.classList.add('hidden');
            icon.classList.remove('rotate-180');
            
            if (trigger.classList.contains('bg-dark-blue')) {
                trigger.classList.remove('bg-dark-blue');
                trigger.classList.add('bg-[#1F3D7C]');
            }
        });
    }

    toggleDropdown(event) {
        event.stopPropagation();
        const trigger = event.currentTarget;
        const wrapper = trigger.closest('[data-navigation-target="dropdownWrapper"]');
        const content = wrapper.querySelector('[data-navigation-target="dropdownContent"]');
        const icon = wrapper.querySelector('[data-navigation-target="dropdownIcon"]');
        
        const modalOpen = document.querySelector('[data-modal-target="wrapper"]:not(.hidden)');
        if (modalOpen) {
            content.classList.remove('hidden');
            icon.classList.add('rotate-180');
            return;
        }

        const isCurrentlyHidden = content.classList.contains('hidden');
        
        this.closeAllDropdowns();
        
        if (isCurrentlyHidden) {
            content.classList.remove('hidden');
            icon.classList.add('rotate-180');
            
            if (trigger.classList.contains('bg-[#1F3D7C]')) {
                trigger.classList.remove('bg-[#1F3D7C]');
                trigger.classList.add('bg-dark-blue');
            }
        }
    }
}